(ns ui.view.survey.view
    (:require
     [common.localization :as loc]
     [re-frame.core :as rf]
     [reagent.core :as r]
     [ui.components.button.view :as button]
     [ui.view.survey.event :as event]
     [ui.view.survey.form :as form]
     [ui.view.survey.full-grid :as full-grid]
     [ui.view.survey.grid :as grid]
     [ui.view.survey.sub :as sub]
     [ui.view.survey.thank-you-view :as thank-you-view]))

(defn errors-body
  [survey-id]
  (let [sorted-error-cells @(rf/subscribe [::sub/cell-parse-errors survey-id])]
    [:div
     {:class-name "p-4 flex flex-col"}
     [:h2
      {:class-name "pb-2"}
      (loc/tr :some-excel-cells-could-not-be-resolved [(count sorted-error-cells)])]
     [:ul
      {:class "max-h-[50vh] flex flex-col overflow-auto"}
      [:li
       {:class-name "flex flex-row justify-stretch"}
       [:span
        {:class-name "p-2 flex shrink-0 grow-0 w-20 text-helper-light-text bg-helper-light"}
        (loc/tr :cell-address)]
       [:span
        {:class-name "p-2 flex flex-auto text-helper-light-text bg-helper-light"}
        (loc/tr :error)]]
      (->> sorted-error-cells
           (map (fn [[cell error]]
                  ^{:key (str "survey-" survey-id "-cell-" cell "-error")}
                  [:li
                   {:class-name "flex flex-row justify-stretch"}
                   [:span
                    {:class-name "pl-2 w-20 flex shrink-0 grow-0"}
                    cell]
                   [:span
                    {:class-name "pl-2 flex flex-auto"}
                    error]]))
           (doall))]
     [:div
      {:class-name "pt-2 flex flex-row gap-2"}
      [button/secondary-hollow
       {:on-click (fn []
                    (rf/dispatch [::event/download-error-file survey-id]))}
       (loc/tr :show-in-excel)]
      [button/secondary-open
       {:on-click (fn []
                    (rf/dispatch [::event/clear-errors survey-id]))}
       (loc/tr :ok)]]]))

(defn uploading-body
  []
  [:div
   {:class "py-8 flex flex-col gap-4 items-center justify-center"}
   [:svg
    {:class   "animate-spin h-8 w-8 mr-3 text-base-light-text fill-[#fff]"
     :viewBox "0 0 24 24"}
    [:circle
     {:class "opacity-75" :cx "12" :cy "12" :r "10" :stroke "currentColor" :stroke-width "4"}]
    [:path
     {:class "opacity-75" :fill "currentColor" :d "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"}]]
   (loc/tr :processing)])

(defn loading-view
  []
  [:div
   {:class "py-8 flex flex-col gap-4 items-center justify-center"}
   [:svg
    {:class   "animate-spin h-8 w-8 mr-3 text-base-light-text fill-[#fff]"
     :viewBox "0 0 24 24"}
    [:circle
     {:class "opacity-75" :cx "12" :cy "12" :r "10" :stroke "currentColor" :stroke-width "4"}]
    [:path
     {:class "opacity-75" :fill "currentColor" :d "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"}]]
   (loc/tr :loading)])

(defn- view-render
  [configuration]
  (let [survey-id (:db/id configuration)
        submitted? @(rf/subscribe [::sub/survey-submitted? survey-id])
        form-style @(rf/subscribe [::sub/form-style-survey survey-id])
        uploading? @(rf/subscribe [::sub/uploading? survey-id])
        loading-completed? @(rf/subscribe [::sub/survey-loading-complete? survey-id])]
    (cond (not loading-completed?)
          [loading-view]
          submitted?
          [thank-you-view/view survey-id]
          uploading?
          [uploading-body]
          :else
          (case form-style
            :survey-form.style/form [form/view survey-id]
            :survey-form.style/grid [grid/view survey-id]
            :survey-form.style/grid-full [full-grid/view survey-id]))))

(defn view
  [configuration access-to-other-surveys? hide-separator-popup?]
  (r/create-class
    {:component-did-mount
     (fn [_]
       (rf/dispatch [::event/init configuration access-to-other-surveys? hide-separator-popup?]))

     :component-did-update
     (fn [this [_ old-configuration]]
       (let [[_ new-configuration] (r/argv this)]
         (when (not= (:previous-answers old-configuration) (:previous-answers new-configuration))
           (rf/dispatch [::event/update-configuration new-configuration]))))

     :component-will-unmount
     (fn [_]
       (rf/dispatch [::event/cleanup-survey (:db/id configuration)]))

     :reagent-render
     view-render}))
